import React, { useEffect, useState } from 'react'
// import './App.css';
import { Dashboard } from './Dashboard/Dashboard';
import { Main } from './Main/Main';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import axios from 'axios';
import { Admin } from './Admin/Admin';
import { Participants } from './Dashboard/Participants';
import { Questions } from './Questions/Questions';
import { ParticipantDashboard } from './ParticipantDashboard/ParticipantDashboard';
import { Quiz } from './Quiz/Quiz';
import { Maintenance } from './Maintenance/Maintenance';
import { NotFound } from './NotFound/NotFound';
import { SampleQuiz } from './SampleQuiz/SampleQuiz';
axios.defaults.baseURL = "https://endpoint.e-dats.info" //uncomment for production
// axios.defaults.baseURL = "http://localhost/denr-endpoints" //uncomment for development
// axios.defaults.baseURL = "http://localhost:8000" //uncomment for development
// axios.defaults.baseURL = "http://192.168.1.11:8000"
// axios.defaults.baseURL = "http://localhost:8000"
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Accept'] = 'application/json';

function App() {
  const user = localStorage.getItem('name');
  console.log(user)
  const userType = localStorage.getItem('user_type');
  const showDashboard = (userType) =>{
    switch(userType){
      //Participants
      case '0':
        <Route path={`/dashboard`} element={
            <ProtectedRoute user={user}>
              <Dashboard />
            </ProtectedRoute>}>
            <Route index element={<Dashboard name={user} />} />
        </Route>
      break;
      case '1':
        return (
          <Route path={`/admin`} element={
              <ProtectedRoute user={user}>
                <Dashboard />
              </ProtectedRoute>}>
              <Route index element={<Participants name={user} />} />
          </Route>
        )
      break;
      
    }
  }
  const maintenanceRouter = createBrowserRouter([
    {
      path: "/",
      element: <Maintenance/>,
    },{
      path: "*",
      exact:true,
      element: <NotFound/>,
    },
  ]);
  return (
    <>
    {
      process.env.REACT_APP_SITE_MODE === 'LIVE'
      ?
      <React.StrictMode>
        <BrowserRouter>
          <Routes>
            <Route path={'/'} element={<IsLogin user={user} userType = {userType}>
              <Main />
            </IsLogin>} />
            {/* {showDashboard(userType)} */}
            
            {/* <Route path='*' exact={true} element={<NotFound/>} /> */}
            {/* <Route path='/admin' element={<Admin/>} /> */}
            {/* <Route path='/dashboard' element={<Dashboard/>} /> */}
            <Route path={`/admin`} element={
                <ProtectedRoute user={user}>
                  <Admin />
                </ProtectedRoute>}>
                <Route index element={<Participants name={user} />} />
                <Route path='/admin/questions' element={<Questions/>} />
                <Route path='/admin/quiz' element={<Quiz/>} />
                <Route path='/admin/sample-quiz' element={<SampleQuiz/>} />

            </Route>
            <Route path={`/dashboard`} element={
                <ProtectedRoute user={user}>
                  <Dashboard />
                </ProtectedRoute>}>
                <Route index element={<ParticipantDashboard name={user} />} />
            </Route>
        </Routes>
        </BrowserRouter>
      </React.StrictMode>
      :
      <React.StrictMode>
        <RouterProvider router={maintenanceRouter} />
      </React.StrictMode>
    }
    </>
    
  );
}

export default App;
function ProtectedRoute({ user, children }) {
  if (!user) {
    return <Navigate to={`/`} replace />;
  }
  return children;
};
function IsLogin({ user, userType, children }) {
  if (user) {
    if(userType === 0){
      return <Navigate to={`/dashboard`} replace />;
    }else{
      return <Navigate to={`/admin`} replace />;
    }
  }
  return children;
};
